import { Column, Grid } from "@carbon/react";
import { Link } from "react-router-dom";

import { CurrencyDisplay } from "../../../../components";

export const View = ({
  title,
  subtitle,
  viewAllUrl,
  data,
  total,
  totalCurrencySymbol,
  renderRow,
}) => {
  return (
    <Column className="inline-table split-pane--left">
      <Grid className="header-container">
        <Column sm={4} md={8} lg={16}>
          <h5>{title}</h5>
        </Column>

        <Column sm={4} md={8} lg={16}>
          <div className="flex-container">
            <small className="flex-box inline-table--subtitle">
              {subtitle}
            </small>

            <Link to={viewAllUrl}>View all</Link>
          </div>
        </Column>
      </Grid>

      <div className="over">
        <table>
          {data.map((val, key) => {
            return (
              <tr key={key} className="small-font--table">
                {renderRow(val)}
              </tr>
            );
          })}
        </table>
      </div>

      <div className="flex-container total font-ctm--semibold">
        <div className="flex-box">
          <h6>Total</h6>
        </div>

        <h5>
          <CurrencyDisplay
            currencySymbol={totalCurrencySymbol}
            amount={total}
            fontSize={14}
            amountClassName="font-ctm--bold"
          />
        </h5>
      </div>
    </Column>
  );
};
